'use strict';
import {getOrganization} from '../../app/model/reducers/state';


module.exports = [
  '$modal',
  '$scope',
  '$ngRedux',
  'currentValue',
  'currentFilter',
  'nullLabel',
  'exclusions',
  'overrideOrg',
  PersonnelSelectController];

function PersonnelSelectController($modal, $scope, $ngRedux, currentValue, currentFilter, nullLabel, exclusions, overrideOrg) {
  const vm = $scope.selector = {
    onSelect: onSelect,
    cancel: cancel,
    currentValue: currentValue,
    currentFilter: currentFilter,
    nullable: nullLabel || 'Unassigned', // TODO(i18n): improve fallback and convert to handle i18n
    exclusions: exclusions,

    organization: overrideOrg || getOrganization($ngRedux.getState()),
  };

  function onSelect(result) {
    document.getElementById("search-filter").blur();
    $modal.hide(result);
  }

  function cancel() {
    document.getElementById("search-filter").blur();
    $modal.cancel();
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/selectors/PersonnelSelectController.js